/**
 * creator:
 * date: 2021/6/16 下午3:16:24
 * path:
 * description:
 * @link:
 */
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import { Loading } from 'components';

const Spin = () => <Loading loading />;

const Main = Loadable({
	loader: () => import('./main.js'),
	loading: Spin,
});

const Detail = Loadable({
	loader: () => import('./routes/detail/index.js'),
	loading: Spin,
});

export default ({ match }) => {
	return (
		<Switch>
			<Route path= {`${match.url}/detail/:id`} component={Detail} />
			<Route path= {match.url} component={Main} />
		</Switch>
	);
};
